import { RootState } from '@/store/types';
import { GetterTree } from 'vuex';
import { FirmwareState, ParsedFirmware, Firmware } from './types';

export const getters: GetterTree<FirmwareState, RootState> = {
  parsedFirmwares(state): ParsedFirmware[] {
    const firmware: Firmware | undefined = state.firmware;
    const firmwares: ParsedFirmware[] = [];

    if (!firmware) {
      return firmwares;
    }

    const m1: ParsedFirmware = {
      type: 'm1',
      version: firmware.m1,
      md5: firmware.md5M1,
      url: firmware.urlM1,
    };

    const m2: ParsedFirmware = {
      type: 'm2',
      version: firmware.m2,
      md5: firmware.md5M2,
      url: firmware.urlM2,
    };

    firmwares.push(m1);
    firmwares.push(m2);

    return firmwares;
  },
};
